import { InputField, LoaderButton } from 'components/molecules'
import { Form, Formik } from 'formik'
import PropTypes from 'prop-types'

const propTypes = {
  product          : PropTypes.object,
  handleSubmitForm : PropTypes.func
}

const defaultProps = {
  product          : { },
  handleSubmitForm : () => { }
}

const ProductNonrefundableReasonsForm = ({
  product,
  handleSubmitForm
}) => {
  const initialValues = {
    nonrefundable_reasons: product.nonrefundable_reasons
  }

  return (
    <Formik
      initialValues={ initialValues }
      onSubmit={ handleSubmitForm }
      enableReinitialize={ true }
    >
      {
        (formik) => (
          <Form>
            <InputField
              name='nonrefundable_reasons'
              label='Nonrefundable reasons'
              placeholder='Alasan produk tidak dapat dikembalikan'
              type='text'
            />

            <div className='d-flex justify-content-center position-sticky fixed-bottom bg-white py-3'>
              <LoaderButton
                className='float-right'
                color='primary'
                type='submit'
                disabled={ formik.isSubmitting }
                isLoading={ formik.isSubmitting }
                text={ 'Submit' }
              />
            </div>

          </Form>
        )
      }

    </Formik>
  )

}

ProductNonrefundableReasonsForm.propTypes    = propTypes
ProductNonrefundableReasonsForm.defaultProps = defaultProps

export default ProductNonrefundableReasonsForm